import * as React from "react";
import { observer } from "mobx-react";
import { Redirect } from "react-router";
import { LoginStore } from "../modules/login/LoginStore";

type IStates = {
  isVisible: boolean;
};

@observer
class PrivateRoute extends React.Component<any, IStates> {
  constructor(props: any) {
    super(props);

    this.state = {
      isVisible: false,
    };

    this._auth();
  }

  /**
   * Auth event for private routes
   */
  _auth = async () => {
    try {
      // Await user validation
      await LoginStore.addListenerToVerifySession();
      this.setState({ isVisible: true });
    } catch (e) {
      this.setState({ isVisible: true });
    }
  };

  public render() {
    let { Component } = this.props;
    if (!this.state.isVisible) return <div />;
    else if (LoginStore.userAuth !== undefined) return <Component />;
    return (
      <Redirect
        to={{ pathname: "/login", state: { from: this.props.location } }}
      />
    );
  }
}

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/common/PrivateRoute.tsx